export default "__VITE_ASSET__BPPAD0V7__"